import { FormattedMessage } from 'react-intl';
import advancedMapLayersSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-advanced-map-layers.avif';
import customRoutesSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-custom-routes.avif';
import offlineMapsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-offline-maps.avif';
import routeAssistantSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-route-assistant.avif';
import trailConditionsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-trail-conditions.avif';
import UpsellFeatureList from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/UpsellFeatureList';
import memberDealsSrc from './feature-thumb-member-deals.avif';
import plusIncludesSrc from './all-plus.avif';

const memberDealsRow = {
  body: <FormattedMessage defaultMessage="Exclusive savings on apparel, outdoor accommodations, flights, and more" />,
  src: memberDealsSrc,
  title: <FormattedMessage defaultMessage="Member Deals" />
};

const trailConditionsRow = {
  body: <FormattedMessage defaultMessage="Plan for trail-specific weather, snow depth, and more" />,
  src: trailConditionsSrc,
  title: <FormattedMessage defaultMessage="Trail Conditions" />
};

const rows = (isInUs: boolean) => [
  {
    body: <FormattedMessage defaultMessage="Plan backpacking trips effortlessly with our built-in assistant" />,
    src: routeAssistantSrc,
    title: <FormattedMessage defaultMessage="Route Assistant" />
  },
  {
    body: <FormattedMessage defaultMessage="Get detailed views of the land and terrain before you go" />,
    src: advancedMapLayersSrc,
    title: <FormattedMessage defaultMessage="Advanced Map Layers" />
  },
  {
    body: <FormattedMessage defaultMessage="Start from scratch or customize to create your perfect adventure in the app" />,
    src: customRoutesSrc,
    title: <FormattedMessage defaultMessage="Custom Routes" />
  },
  {
    body: <FormattedMessage defaultMessage="Download maps so you always know where you are, even without cell service" />,
    src: offlineMapsSrc,
    title: <FormattedMessage defaultMessage="Offline Maps" />
  },
  isInUs ? memberDealsRow : trailConditionsRow
];

// TODO translate: https://alltrails.atlassian.net/browse/GROW-18496
const reiRows = [
  {
    body: 'Plan backpacking trips effortlessly with our built-in assistant',
    src: routeAssistantSrc,
    title: 'Route Assistant'
  },
  {
    body: 'Get detailed views of the land and terrain before you go',
    src: advancedMapLayersSrc,
    title: 'Advanced Map Layers'
  },
  {
    body: 'Start from scratch or customize to create your perfect adventure in-app',
    src: customRoutesSrc,
    title: 'Custom Routes'
  },
  {
    body: 'Unlimited map downloads, real-time trail conditions, wrong-turn alerts, 3D trail previews and more!',
    src: plusIncludesSrc,
    title: '...and AllTrails Plus benefits!',
    unframedThumbnail: true
  }
];

type Props = {
  isInUs: boolean;
  isRei?: boolean;
};

export default function PeakMembershipIncludes({ isInUs, isRei }: Props) {
  if (isRei) {
    // TODO translate: https://alltrails.atlassian.net/browse/GROW-18496
    return <UpsellFeatureList label="Advanced tools for backpackers and bigger adventures" rows={reiRows} />;
  }

  return <UpsellFeatureList label={<FormattedMessage defaultMessage="Peak membership includes" />} rows={rows(isInUs)} variant="compact" />;
}
